import { render, staticRenderFns } from "./PSOEBVOH.vue?vue&type=template&id=6f146600&scoped=true&"
import script from "./PSOEBVOH.vue?vue&type=script&lang=js&"
export * from "./PSOEBVOH.vue?vue&type=script&lang=js&"
import style0 from "./PSOEBVOH.vue?vue&type=style&index=0&id=6f146600&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f146600",
  null
  
)

export default component.exports